<template>
  <div class="items-list-table">
    <div class="items-list-header items-list-row">
      <div class="items-list-td-product">
        <span class="items-list-title-header">
          <b-form-checkbox v-model="selectAllLocal" @change="onSelectAllChanged">Produto</b-form-checkbox>
        </span>
      </div>
      <div class="items-list-header-right">
        <label v-if="!operational && totalLoading > 1" class="items-filter">
          <input
              v-model="withAccessoryLocal"
              class="items-checkbox-filter-input"
              type="checkbox"
              @change="onFilterChanged"
          />
          <span class="items-checkbox-filter-box"></span>
          <span class="items-filter-text">Mostrar acessórios</span>
        </label>
        <label v-if="!operational && totalLoading > 1" class="items-filter">
          <input
              v-model="withOnlyStockLocal"
              class="items-checkbox-filter-input"
              type="checkbox"
              @change="onFilterChanged"
          />
          <span class="items-checkbox-filter-box"></span>
          <span class="items-filter-text">Mostrar operacionais</span>
        </label>
      </div>
    </div>

    <draggable
        v-model="itemsLocal"
        group="masters"
        handle=".draggable-drag-handle"
        item-key="__key"
        :disabled="loading"
        @end="onDragEndMasters"
    >
      <div
          v-for="(master, masterIndex) in itemsLocal"
          :key="'master-' + (master.__key || master.id || masterIndex)"
          class="items-list-tbody"
      >
        <div class="items-list-row items-list-group-master">
          <div class="items-list-level items-list-level-1">
            <i class="fa-solid fa-grip-vertical draggable-drag-handle items-list-rent-row-icon-layer"></i>
            <i class="fa-solid fa-layer-group items-list-icon-order-group"></i>

            <span
                class="items-list-title-group title"
                @click="!withoutGroupStructure && onStartEditGroup(master, masterIndex)"
                :style="{ cursor: withoutGroupStructure ? 'default' : 'pointer' }"
            >
              <template v-if="editing.type === 'group' && editing.masterIndex === masterIndex">
                <div class="items-inline-edit-wrap">
                  <input
                      v-model="editing.value"
                      @keyup.enter="onCommitEditGroup"
                      @blur="onCommitEditGroup"
                      class="items-inline-edit"
                      type="text"
                  />
                  <i class="fa-solid fa-check items-inline-edit-ok" @click="onCommitEditGroup"></i>
                </div>
              </template>
              <template v-else>
                {{ master.groupName }}
                <span v-if="!withoutGroupStructure" class="items-list-tooltip-wrapper">
                  <i
                      class="fa-regular fa-pen-to-square items-list-draggable-edit-icon"
                      role="button"
                      @click.stop="onStartEditGroup(master, masterIndex)"
                  ></i>
                  <span class="items-list-tooltip-box">Editar grupo</span>
                </span>
                <span v-if="!withoutGroupStructure" class="items-list-tooltip-wrapper">
                  <i
                      class="fa-solid fa-plus items-list-draggable-edit-icon"
                      role="button"
                      style="margin-left:8px;color:#16a34a;"
                      @click.stop="onAddSubgroup(master, masterIndex)"
                  ></i>
                  <span class="items-list-tooltip-box">Adicionar subgrupo</span>
                </span>
                <span v-if="!withoutGroupStructure" class="items-list-tooltip-wrapper">
                  <i
                      class="fa-solid fa-xmark items-list-draggable-edit-icon"
                      role="button"
                      style="margin-left:8px;color:#ef4444;"
                      @click.stop="onRemoveGroup(master, masterIndex)"
                  ></i>
                  <span class="items-list-tooltip-box">Excluir grupo</span>
                </span>
              </template>
            </span>
          </div>
        </div>

        <draggable
            :list="getMasterByKey(master).subGroups"
            handle=".draggable-sub-drag-handle"
            item-key="__key"
            :disabled="loading"
            @end="onDragEndSubgroups(master, masterIndex)"
        >
          <div
              v-for="(subgroup, subgroupIndex) in getMasterByKey(master).subGroups"
              :key="'group-' + (subgroup.__key || subgroup.groupId || subgroup.id || subgroupIndex)"
          >
            <div class="items-list-row items-list-row-subgroup items-list-group">
              <div class="items-list-group-cell">
                <div class="items-list-level items-list-level-2">
                  <span
                      class="items-list-title-group title"
                      @click="!withoutGroupStructure && onStartEditSubgroup(subgroup, masterIndex, subgroupIndex)"
                      :style="{ cursor: withoutGroupStructure ? 'default' : 'pointer' }"
                  >
                    <template
                        v-if="editing.type === 'subgroup' && editing.masterIndex === masterIndex && editing.subgroupIndex === subgroupIndex">
                      <div class="items-inline-edit-wrap">
                        <input
                            v-model="editing.value"
                            @keyup.enter="onCommitEditSubgroup"
                            @blur="onCommitEditSubgroup"
                            class="items-inline-edit"
                            type="text"
                        />
                        <i class="fa-solid fa-check items-inline-edit-ok" @click="onCommitEditSubgroup"></i>
                      </div>
                    </template>
                    <template v-else>
                      <i class="fa-regular fa-layer-group items-list-icon-order-group"></i>
                      <i class="fa-solid fa-grip-lines items-list-rent-row-icon-layer draggable-sub-drag-handle"></i>
                      {{ subgroup.groupName }}

                      <span class="items-list-tooltip-wrapper">
                        <i
                            class="fas fa-plus-circle items-list-add-product-icon"
                            role="button"
                            @click.stop="onAddProductToSubgroup(subgroup)"
                        ></i>
                        <span class="items-list-tooltip-box">Adicionar produto</span>
                      </span>

                      <span v-if="!withoutGroupStructure" class="items-list-tooltip-wrapper">
                        <i
                            class="fa-regular fa-pen-to-square items-list-draggable-edit-icon"
                            role="button"
                            @click.stop="onStartEditSubgroup(subgroup, masterIndex, subgroupIndex)"
                        ></i>
                        <span class="items-list-tooltip-box">Editar subgrupo</span>
                      </span>

                      <span v-if="!withoutGroupStructure" class="items-list-tooltip-wrapper">
                        <i
                            class="fa-solid fa-xmark items-list-draggable-edit-icon"
                            role="button"
                            style="margin-left:8px;color:#ef4444;"
                            @click.stop="onRemoveSubgroup(master, masterIndex, subgroup, subgroupIndex)"
                        ></i>
                        <span class="items-list-tooltip-box">Excluir subgrupo</span>
                      </span>
                    </template>
                  </span>
                </div>
              </div>
            </div>

            <draggable
                :list="getMasterByKey(master).__subGroupsRef[subgroupIndex].products"
                tag="div"
                :data-group-id="subgroup.groupId || subgroup.id || null"
                :data-master-id="master.groupId || master.id || null"
                :group="{ name: 'products', pull: true, put: true }"
                item-key="id"
                @change="onDragChangeProduct($event, master, subgroup, masterIndex, subgroupIndex)"
                @end="onDragEndProducts($event, master, subgroup, masterIndex, subgroupIndex)"
            >
              <div
                  v-for="(product, productIndex) in subgroup.products"
                  v-show="productMatchesSearch(product)"
                  :key="'prod-' + (product.id || productIndex)"
              >
                <ItemsRentRow
                    :rent="rent"
                    :item="product"
                    :operational="operational"
                    :totalRecords="subgroup.products.length"
                />
              </div>
            </draggable>
          </div>
        </draggable>
      </div>
    </draggable>

    <div v-if="!itemsLocal.length && !loading" class="items-list-row">
      <div class="items-list-group-cell">
        <span class="items-list-empty">
          Nenhum registro encontrado, clique no + Grupo para
          <b>adicionar</b>, <b>editar</b> grupos/subgrupos e <b>arrastar para ordenar</b>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import ItemsRentRow from "../ItemsRentRow.vue";
import draggable from "vuedraggable";

export default {
  name: "ItemsRentGroupTable",
  components: {
    draggable,
    ItemsRentRow,
  },
  props: {
    rent: {type: Object, required: true},
    items: {type: Array, default: () => []},
    loading: {type: Boolean, default: false},
    operational: {type: Boolean, default: false},
    selectAll: {type: Boolean, default: false},
    withAccessory: {type: Boolean, default: false},
    withOnlyStock: {type: Boolean, default: false},
    withoutGroupStructure: {type: Boolean, default: false},
    totalLoading: {type: Number, default: 1},
    searchQuery: {type: String, default: ""},
    editing: {
      type: Object,
      default: () => ({type: null, masterIndex: null, subgroupIndex: null, target: null, value: ""}),
    },
  },
  computed: {
    itemsLocal: {
      get() {
        return this.items;
      },
      set(value) {
        this.$emit("update:items", value);
      },
    },
    selectAllLocal: {
      get() {
        return this.selectAll;
      },
      set(value) {
        this.$emit("update:selectAll", value);
      },
    },
    withAccessoryLocal: {
      get() {
        return this.withAccessory;
      },
      set(value) {
        this.$emit("update:withAccessory", value);
      },
    },
    withOnlyStockLocal: {
      get() {
        return this.withOnlyStock;
      },
      set(value) {
        this.$emit("update:withOnlyStock", value);
      },
    },
  },
  methods: {
    productMatchesSearch(product) {
      const q = (this.searchQuery || "").trim().toLowerCase();
      if (!q) return true;
      return (product.productFullName || "").toLowerCase().includes(q);
    },
    getMasterByKey(master) {
      if (!master) return master;
      const key = master.__key || null;
      const id = master.groupId || master.id || null;
      const found = (this.items || []).find(
          (x) =>
              (key && x.__key === key) ||
              (!key && id && (x.groupId === id || x.id === id))
      );
      if (found && !found.__subGroupsRef) found.__subGroupsRef = found.subGroups || [];
      if (found) found.__subGroupsRef = found.subGroups || [];
      return found || master;
    },
    onSelectAllChanged(value) {
      this.$emit("select-all-changed", value);
    },
    onFilterChanged() {
      this.$emit("filter-changed");
    },
    onStartEditGroup(master, masterIndex) {
      this.$emit("start-edit-group", {master, masterIndex});
    },
    onCommitEditGroup() {
      this.$emit("commit-edit-group");
    },
    onAddSubgroup(master, masterIndex) {
      this.$emit("add-subgroup", {master, masterIndex});
    },
    onRemoveGroup(master, masterIndex) {
      this.$emit("remove-group", {master, masterIndex});
    },
    onStartEditSubgroup(subgroup, masterIndex, subgroupIndex) {
      this.$emit("start-edit-subgroup", {subgroup, masterIndex, subgroupIndex});
    },
    onCommitEditSubgroup() {
      this.$emit("commit-edit-subgroup");
    },
    onRemoveSubgroup(master, masterIndex, subgroup, subgroupIndex) {
      this.$emit("remove-subgroup", {master, masterIndex, subgroup, subgroupIndex});
    },
    onAddProductToSubgroup(subgroup) {
      this.$emit("add-product-to-subgroup", subgroup);
    },
    onDragEndMasters() {
      this.$emit("drag-end-masters");
    },
    onDragEndSubgroups(master, masterIndex) {
      this.$emit("drag-end-subgroups", {master, masterIndex});
    },
    onDragChangeProduct(event, master, subgroup, masterIndex, subgroupIndex) {
      this.$emit("drag-change-product", {event, master, subgroup, masterIndex, subgroupIndex});
    },
    onDragEndProducts(event, master, subgroup, masterIndex, subgroupIndex) {
      this.$emit("drag-end-products", {event, master, subgroup, masterIndex, subgroupIndex});
    },
  },
};
</script>

<style scoped>
.items-list-table {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
  background: transparent;
}

.items-list-header,
.items-list-row {
  display: flex;
  align-items: center;
}

.items-list-header > div,
.items-list-row > div {
  padding: 7px 10px 5px 10px;
}

.items-list-td-product {
  width: 200px;
}

.items-list-header-right {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-left: auto;
  text-align: right;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.items-filter {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  background: #f8fafc;
  cursor: pointer;
  position: relative;
}

.items-checkbox-filter-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.items-checkbox-filter-box {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.items-checkbox-filter-input:checked + .items-checkbox-filter-box {
  background: #4BB4E2;
  border-color: #4BB4E2;
}

.items-checkbox-filter-input:checked + .items-checkbox-filter-box::after {
  content: "";
  width: 8px;
  height: 4px;
  border-left: 2px solid #ffffff;
  border-bottom: 2px solid #ffffff;
  transform: rotate(-45deg);
}

.items-filter-text {
  font-size: 12px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.items-list-group-master {
  background-color: #e3e5ed;
  font-weight: 600;
}

.items-list-group {
  background-color: #f6f6f8;
  font-weight: 500;
}

.items-list-group-cell {
  width: 100%;
  padding: 8px 10px;
}

.items-list-level-1 {
  padding-left: 10px;
}

.items-list-level-2 {
  padding-left: 30px;
}

.items-list-title-group {
  font-size: 14px;
}

.items-list-icon-order-group {
  color: #2563eb;
  margin-right: 6px;
}

.items-list-empty {
  color: #757d8c;
  font-style: italic;
}

.items-list-rent-row-icon-layer {
  color: #9ca3af;
  cursor: grab;
  margin-right: 5px;
}

.items-list-add-product-icon {
  color: #577696;
  margin-left: 5px;
  right: 0;
}

.items-list-draggable-edit-icon {
  font-size: 13px;
  margin-left: 6px;
  color: #cbd5e1;
  transition: color 0.2s;
  cursor: pointer;
}

.items-inline-edit {
  font-size: 14px;
  padding: 2px 28px 2px 6px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  outline: none;
  width: 280px;
}

.items-inline-edit-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.items-inline-edit-ok {
  position: absolute;
  right: 8px;
  color: #16a34a;
  cursor: pointer;
  font-size: 13px;
}

.items-inline-edit-ok:hover {
  color: #15803d;
}

.items-list-tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.items-list-tooltip-box {
  position: absolute;
  white-space: nowrap;
  background: rgba(0, 0, 0, 0.87);
  color: #fff;
  padding: 6px 8px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 300;
  opacity: 0;
  pointer-events: none;
  z-index: 60;
  left: 50%;
  bottom: 100%;
  transform: translateX(-50%) translateY(6px);
  transition: opacity 0.12s ease, transform 0.12s ease;
}

.items-list-tooltip-wrapper:hover .items-list-tooltip-box {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

.items-list-tooltip-box::after {
  content: "";
  position: absolute;
  border: 6px solid transparent;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-top-color: rgba(0, 0, 0, 0.87);
}

</style>
